import { render } from "./NotificationsDayTitle.vue?vue&type=template&id=d955479e&scoped=true"
import script from "./NotificationsDayTitle.vue?vue&type=script&lang=js"
export * from "./NotificationsDayTitle.vue?vue&type=script&lang=js"

import "./NotificationsDayTitle.vue?vue&type=style&index=0&id=d955479e&lang=scss&scoped=true"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d955479e"]])

export default __exports__